import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor() { }

  bool(value: any): boolean {
    if (value != null && value != false && (value == true || value.toUpperCase() == 'TRUE'))
      return true;
    else
      return false;
  }

  replacer(inp: any, froms: any[], to: any) {
    for (let k in inp) {
      let t = froms.find(x => x === inp[k])
      if (t || (inp[k] == '' && t == '') || (inp[k] == null && t == null)) { inp[k] = to }
      else if (typeof inp[k] == 'object' || typeof inp[k] == '' + 'array') this.replacer(inp[k], froms, to)
    }
  }

  replacer0(inp: any, froms: any[], to: any) {
    for (let k of inp) {
      let t = froms.find(x => x === inp[k])
      if (t || (inp[k] === '' && t === '') || (inp[k] === null && t === null)) { inp[k] = to }
      else if (typeof inp[k] == 'object' || typeof inp[k] == '' + 'array') this.replacer(inp[k], froms, to)
    }
  }

  reverse(str: string) {
    var nstr = "";
    for (var i = str.length - 1; i >= 0; i--)
      nstr += str[i];
    return nstr;
  }

  separate(val: any, char: string, length: number) {
    val = this.reverse(val.toString());
    return this.reverse(val.match(new RegExp('.{1,' + length + '}', 'g')).join(char));
  }

  export_page(share: { id: string, tit: string, dats: string[][], cols: any[], header: string, footer: string }, pip: any, print: {}, excel: { url: string, param: string, nam: string }, model: any, cnf: { which: number }) { // elem or id or hdoc  // any, header, footer, excel,
    var html = `<!doctype html>
    <html lang="en" dir="rtl">
    
    <head>
      <!--- required meta tags --------------------->
      <meta charset="utf-8">
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <base href="/">
    
      <link rel="icon" type="image/x-icon" href="favicon.ico">
    
      <!-- vendors --------------------------------->
      <link rel="stylesheet" href="vendors/bootstrap.rtl.css">
      <link rel="stylesheet" href="vendors/bootstrap-icons.css">
      <link rel="stylesheet" href="vendors/toastr.css">
    
      <!-- themes css ------------------------------>
      <link id="theme_base_bootstrap-theme" rel="stylesheet" href="assets/themes/base/css/bootstrap-theme.css">
      <link id="theme_base_bootstrap-modifier" rel="stylesheet" href="assets/themes/base/css/bootstrap-modifier.css">
      <link id="theme_base_font" rel="stylesheet" href="assets/themes/base/css/font.css">
      <link id="theme_base_struct" rel="stylesheet" href="assets/themes/base/css/struct.css">
      <link id="theme_base_menu" rel="stylesheet" href="assets/themes/base/css/menu.css">
      <link id="theme_base_page" rel="stylesheet" href="assets/themes/base/css/page.css">
      <link id="theme_base_login" rel="stylesheet" href="assets/themes/base/css/login.css">
      <link id="theme_base_grid" rel="stylesheet" href="assets/themes/base/css/grid.css">
      <link id="theme_base_formy" rel="stylesheet" href="assets/themes/base/css/formy.css">
      <link id="theme_base_chart" rel="stylesheet" href="assets/themes/base/css/chart.css">
      <link id="theme_base_infocard" rel="stylesheet" href="assets/themes/base/css/infocard.css">
      <script type="text/javascript" src="../assets/js/export.js"></script>
  </head>
  <body style="background-color:white">
  <style>
  .num {
    mso-number-format:General;
  }
  .text{
    mso-number-format:"\@";/*force text*/
  }</style>
  <hr>
  <div class="alert alert-dark" role="alert">
  <span class="btn btn-dark btn-sm"    style="width:10rem" onclick="this.parentNode.remove(); print();" ><i class="bi bi-printer"></i> چاپ</span>&nbsp;
  <span class="btn btn-success btn-sm" style="width:10rem" onclick="excel_client('${share.id}', '${excel.nam}');" ><i class="bi bi-file-earmark-excel"></i> فایل Excel</span>
  <span class="btn btn-success btn-sm" style="width:10rem" onclick="csv_client('${share.id}', '${excel.nam}');" ><i class="bi bi-file-earmark-spreadsheet"></i> فایل CSV</span>
  <span class="btn btn-success btn-sm" style="display:none" onclick="this.parentNode.remove(); excel_server(${excel.url}, ${JSON.stringify(excel.param)});" >فایل اکسل از سرور</span>&nbsp;
  </div>${share.header}
  <input type="text" style="display:none; width:400px; margin:20px auto 20px auto" class="fs16px t-center no-borders" />`
    let th = model.num ? '<th>ردیف</th>' : ''
    let th2 = model.num ? '<th>number</th>' : ''
    let sf = '<td></td>'
    let tb = ''

    for (let i = 0; i < share.cols.length; i++)
      if (share.cols[i].dis != 3 || (share.cols[i].vals == 'id' && cnf.which == 2)) {
        th += '<th>' + (share.cols[i].lbl || share.cols[i].vals) + '</th>'
        th2 += '<th>' + (share.cols[i].vals) + '</th>'
        console.log(7000, typeof share.cols[i].smf_res, share.cols[i].smf_res)
        sf += '<td>' + ((share.cols[i].smf_res + '').substring(0, 1) == '-' ? '(' + (share.cols[i].smf_res + '').substring(1) + ')' : share.cols[i].smf_res == undefined ? '' : share.cols[i].smf_res) + '</td>'
      }

    for (let i = 0; i < share.dats.length; i++) {
      tb += '<tr><td>' + (i+1) + '</td>'
      for (let u = 0; u < share.cols.length; u++)
        if (share.cols[u].dis != 3 || (share.cols[u].vals == 'id' && cnf.which == 2)) {
          let val = share.dats[i][u]
          // if (typeof val == 'string' && val.indexOf('◙') != -1){ console.log(u, val, val.split('◙'), val.split('◙')[1]); val = val.split('◙')[1]}
          if (val != null && share.cols[u].pip != null) val = pip.transform(val, model, u)
          if (val == null) val = ''
          if ((val + '').substring(0, 1) == '-') val = '(' + (val + '').substring(1) + ')'
          tb += '<td>' + val + '</td>'
        }
      tb += '</tr>'
    }
    if (cnf.which == 1) th2 = ''
    else th2 = '<tr style="background-color: #ddd !important; font-weight: bold;">' + th2 + '</tr>'

    html += '<table id="' + share.id + '" class="table table-sm table-bordered export" ><thead><tr style="background-color: #ddd !important; font-weight: bold;">' + th + '</tr>' + th2 + '</thead><tbody>' + tb + '</tbody><tfoot><tr style="background-color: #ddd !important; font-weight: bold;">' + sf + '</tfoot></table>'
    html += share.footer
    html += '</body></html>'
    var w = window.open()
    w.document.write(html)
  }

  tocsv(dats) {
    if (dats.length == 0) return ''
    let clen = dats[0].length
    let csv = []
    for (let r = 0; r < dats.length; r++) {
      for (let c = 0; c < clen; c++) {
        if (dats[r][c].indexOf('"') != -1) dats[r][c] = dats[r][c].split('"').join('”')
        if (dats[r][c].indexOf(',') != -1) dats[r][c] = '"' + dats[r][c] + '"'
      }
      csv.push(dats[r].join(','))
    }
    return csv.join('\n')
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  data_former(data = {}, form?, namespace?): FormData { //object_formdata
    let files = {};
    let model = {};
    for (let propertyName in data) {
      if (data.hasOwnProperty(propertyName) && data[propertyName] instanceof File) {
        files[propertyName] = data[propertyName]
      } else {
        model[propertyName] = (data[propertyName] === false ? 'false' : data[propertyName])
      }
    }

    model = JSON.parse(JSON.stringify(model))
    let formData = form || new FormData();

    for (let propertyName in model) {
      if (!model.hasOwnProperty(propertyName) || model[propertyName] === false) continue;

      let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
      if (model[propertyName] instanceof Date)
        formData.append(formKey, model[propertyName].toISOString());
      else if (model[propertyName] instanceof File) {
        formData.append(formKey, model[propertyName]);
      }
      else if (model[propertyName] instanceof Array) {
        model[propertyName].forEach((element, index) => {
          const tempFormKey = `${formKey}[${index}]`;
          if (typeof element === 'object') this.data_former(element, formData, tempFormKey);
          else formData.append(tempFormKey, element.toString());
        })
      }
      else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
        this.data_former(model[propertyName], formData, formKey);
      else
        formData.append(formKey, model[propertyName].toString());
    }

    for (let propertyName in files) {
      if (files.hasOwnProperty(propertyName)) {
        formData.append(propertyName, files[propertyName]);
      }
    }
    return formData;
  }

  TimeSub(time1: any, time2: any) {
    if (time1 == 0 || time1 == '0') time1 = '00000';
    if (time2 == 0 || time2 == '0') time2 = '00000';

    if (!time1 || !this.is_int(time1)) throw 'خطا در تجمیع زمان - ' + time1;
    if (!time2 || !this.is_int(time2)) throw 'خطا در تجمیع زمان - ' + time2;
    time1 = time1 + '';
    time2 = time2 + '';

    if (time1.length < 5) throw 'خطا در تجمیع زمان - ' + time1;
    if (time2.length < 5) throw 'خطا در تجمیع زمان - ' + time2;

    var hh, mm, ss;

    var t1 = this.separate_time_english(time1, ':', 2).split(':');
    var t2 = this.separate_time_english(time2, ':', 2).split(':');

    t1[0] = parseInt(t1[0]);
    t1[1] = parseInt(t1[1]);
    t1[2] = parseInt(t1[2]);
    t2[0] = parseInt(t2[0]);
    t2[1] = parseInt(t2[1]);
    t2[2] = parseInt(t2[2]);

    let s1: number = (t1[0] * 60 * 60) + (t1[1] * 60) + (t1[2]);
    let s2: number = (t2[0] * 60 * 60) + (t2[1] * 60) + (t2[2]);

    if (s1 == s2) return '00000';

    var s: number;
    var flg = false;
    if (s1 > s2)
      s = s1 - s2;
    else {
      s = s2 - s1;
      flg = true;
    }

    hh = Math.floor(s / 3600);
    s = s - (hh * 3600);
    mm = Math.floor(s / 60);
    ss = s - (mm * 60);

    hh = hh + '';
    mm = mm + '';
    ss = ss + '';
    return (flg ? '-' : '') + hh + '' + mm.padStart(2, '0') + '' + ss.padStart(2, '0');
  }

  TimeSum(time1: any, time2: any) {
    if (time1 == 0 || time1 == '0') time1 = '00000';
    if (time2 == 0 || time2 == '0') time2 = '00000';

    if (!time1 || !this.is_int(time1)) throw 'خطا در تجمیع زمان - ' + time1;
    if (!time2 || !this.is_int(time2)) throw 'خطا در تجمیع زمان - ' + time2;
    time1 = time1 + '';
    time2 = time2 + '';

    if (time1.length < 4) throw 'خطا در تجمیع زمان - ' + time1;
    if (time2.length < 4) throw 'خطا در تجمیع زمان - ' + time2;

    var hh, mm, ss;

    var t1 = this.separate_time_english(time1.padStart(5, '0'), ':', 2).split(':');
    var t2 = this.separate_time_english(time2.padStart(5, '0'), ':', 2).split(':');

    t1[0] = parseInt(t1[0]);
    t1[1] = parseInt(t1[1]);
    t1[2] = parseInt(t1[2]);
    t2[0] = parseInt(t2[0]);
    t2[1] = parseInt(t2[1]);
    t2[2] = parseInt(t2[2]);

    let s1: number = (t1[0] * 60 * 60) + (t1[1] * 60) + (t1[2]);
    let s2: number = (t2[0] * 60 * 60) + (t2[1] * 60) + (t2[2]);

    var s = s1 + s2;
    var flg = false;
    if (s < 0) {
      flg = true;
      s = s * -1;
    }

    hh = Math.floor(s / 3600);
    s = s - (hh * 3600);
    mm = Math.floor(s / 60);
    ss = s - (mm * 60);

    hh = hh + '';
    mm = mm + '';
    ss = ss + '';
    return (flg ? '-' : '') + hh + '' + mm.padStart(2, '0') + '' + ss.padStart(2, '0');
  }

  is_int(n) {
    try {
      return !isNaN(n) && parseFloat(n) == parseInt(n, 10);
    }
    catch (e) {
      return false;
    }
  }

  is_numeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  separate_time_english(val, char, _withSecond) {
    val = val + '';

    if (_withSecond)
      return val.substr(0, val.length - 4).padStart(2, '0') + char + val.substr(val.length - 4, 2).padStart(2, '0') + char + val.substr(val.length - 2).padStart(2, '0');
    else (val.length == 6)
    return val.substr(0, val.length - 4).padStart(2, '0') + char + val.substr(val.length - 4, 2).padStart(2, '0');
  }

  pad_start(val: string, len: number, char?: string) {
    if (!char) char = '0'
    for (let i = val.length; i < len; i++)
      val = char + val
    return val
  }

  totime(val: any, sec?: boolean, char?: string) {
    if (!char) char = ':'
    if (!sec) sec = false
    if (!this.is_int(val)) return val

    let h = Math.floor(val / 3600)
    let m = Math.floor((val - h * 3600) / 60)
    let s = val - (h * 3600) - (m * 60)

    if (sec) return this.pad_start(h.toString(), 2, '0') + ':' + this.pad_start(m.toString(), 2, '0') + ':' + this.pad_start(s.toString(), 2, '0')
    else return this.pad_start(h.toString(), 2, '0') + ':' + this.pad_start(m.toString(), 2, '0')
  }

  serialize(obj, prefix) {
    var str = [],
      p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        str.push((v !== null && typeof v === "object") ?
          this.serialize(v, k) :
          encodeURIComponent(k) + "=" + encodeURIComponent(v));
      }
    }
    return str.join("&");
  }

  async exchange(pad, dat, _opt) {
    let out = { err: null, res: pad }
    if (!pad || typeof pad != 'string' || pad.indexOf('([') == -1) return out
    let t1 = _opt && _opt.rem_qoat ? '"([' : '(['
    let t2 = _opt && _opt.rem_qoat ? '])"' : '])'
    let aa = pad.split(t1).join(' ö #').split(t2).join(' ö ')
    let bb = aa.split(' ö ')
    for (let i = 0; i < bb.length; i++) {
      if (bb[i].substr(0, 1) == '#') {
        bb[i] = await eval(bb[i].substr(1))
        bb[i] = JSON.stringify(bb[i])
      }
    }
    out.res = bb.join('')

    return out
  }

  cookie_set(name, value, daysToLive) {
    var cookie = name + "=" + encodeURIComponent(value);
    if (typeof daysToLive === "number") {
      cookie += "; max-age=" + (daysToLive * 24 * 60 * 60);
      document.cookie = cookie;
    }
  }

  cookie_get(name) {
    var cookieArr = document.cookie.split(";");
    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");
      if (name == cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }
}
